<template>
  <div>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
    >
      <template #h__name><div class="table-default__left">Name</div></template>
      <template #h__time_start><div class="table-default__left">Time & Location</div></template>
      <template #name="{ row }">
        <div class="table-default__left table-default__controls">
              <span
                v-tooltip="{ content: row.notes, placement: 'top-end', offset: 10 }"
                class="table-default__activity table-default__activity--notes"
                :class="{'table-default__activity--active': row.notes}"
              ></span>
          <router-link
            :to="{ name: 'climbing-briefings-detail-clients', params: { id: row.id } }"
            class="table-default__link-border"
          >
            {{ row.name }}
          </router-link>
        </div>
      </template>
      <template #time_start="{ row }">
        <div class="table-default__controls table-default__left">
          <span
            class="table-default__activity table-default__activity--briefing table-default__activity--no-events"
            :class="{'table-default__activity--active': row.briefing}"
          ></span>
          <span
            class="table-default__activity table-default__activity--equipment_check table-default__activity--no-events"
            :class="{'table-default__activity--active': row.eq_check}"
          ></span>
          {{ dateMonthFormat(row.date) }}
          {{ row.time_start }} at
          <span v-if="row.location.place_id !== 'ChIJqQRrDoleNxgRANW_07pTSXY'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">{{ row.location.short_name }}</span>
          <span v-else>{{ row.location.short_name }}</span>
        </div>
      </template>
      <template #invoices_count="{ row }">
        <div class="table-default__controls">
          <span
            v-if="row.invoices_count"
            class="status-tag"
            :style="{ 'backgroundColor': row.invoices_count === row.invoices_printed_count ? '#77b017' : '#f0c427' }"
          >
            {{ row.invoices_printed_count }} / {{ row.invoices_count }}
          </span>
          <span
            v-if="row.invoices_unpaid"
            v-tooltip="{ content: 'Unpaid (clarify charge method with sales manager)', placement: 'top-start', offset: 10 }"
            class="status-tag"
            :style="{ 'backgroundColor': '#e85c20' }"
          >
                {{ row.invoices_unpaid }}
              </span>
          <span v-if="!row.invoices_count && !row.invoices_unpaid">-</span>
        </div>
      </template>
      <template #managers="{ row }">
        <div class="table-default__controls">
          <div v-for="manager of row.managers" :key="manager.id" class="table-default__photo">
            <img
              :src="getUserAvatar(manager.crop.crop_url)" alt="Avatar"
              v-tooltip="{ content: manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
        </div>
      </template>
      <template #speech="{ row }">
        <div v-if="row.speech" class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.speech.crop.crop_url)" alt="Avatar"
              v-tooltip="{ content: row.speech.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
        </div>
        <span v-else>-</span>
      </template>
      <template #created_by="{ row }">
        <div class="table-default__controls">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.created_by?.crop?.crop_url)" alt="Avatar"
              v-tooltip="{ content: `${row.created_by?.full_name || ''}`, placement: 'top-start', offset: 10 }"
            >
          </div>
          {{ dateTimeFormat(row.created_at) }}
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowEventModal(row)" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
          </button>
          <button @click="onShowDeleteModal(row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
          </button>
        </div>
      </template>
    </v-client-table>
    <template
      v-if="is_show_table_clients && table_clients.items.length"
    >
      <app-cells><h2 class="title">Unallocated clients</h2></app-cells>
      <v-client-table
        :data="table_clients.items"
        :columns="table_clients.columns"
        :options="table_clients.options"
        class="table-default"
      >
        <template #h__select>
          <label
            v-if="table_clients.items.length && table_clients.items.some(item => !item.briefing || !item.eq_check)"
            class="checkbox checkbox--table"
          >
            <input
              v-model="checked_all"
              type="checkbox"
              name="checked_all"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #h__full_name>
          <div class="table-default__left">Full name</div>
        </template>
        <template #h__hotel>
          <div class="table-default__left">Hotel</div>
        </template>
        <template #h__group>
          <div class="table-default__left">Group</div>
        </template>
        <template #select="{ row }">
          <label v-if="!row.briefing || !row.eq_check" class="checkbox checkbox--table">
            <input
              v-model="checked"
              type="checkbox"
              :value="row"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
            <router-link
              :to="{ name: 'clients-detail', params: { id: row.client.id } }"
              class="table-default__link-border"
            >
              {{ row.client.full_name }}
            </router-link>
            <span v-if="row.age">({{ row.age }} y.o.)</span>
          </div>
        </template>
        <template #hotel="{ row }">
          <router-link
            v-if="row.before"
            :to="{ name: 'reservation-hotels-general', params: { id: row.before.reservation_id } }"
            class="table-default__link-border"
            target="_blank"
          >
            {{ row.before.hotel_name }} ({{ row.before.room_name }})
          </router-link>
          <template v-else>-</template>
        </template>
        <template #group="{ row }">
          <div class="table-default__controls table-default__left">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
                v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            <router-link
              v-if="row.client.group"
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
            <div v-else class="table-default__left">-</div>
          </div>
        </template>
        <template #safari="{ row }">
          <div class="table-default__controls">
            <button
              @click="onShowSafariModal(row.client)"
              type="button"
              v-tooltip="{ content: tooltipContentSafari(row.client.safari), placement: 'top-start', offset: 10, html: true }"
              class="table-default__activity table-default__activity--safari"
              :class="{'table-default__activity--active': row.client.safari.length}"
            >
            </button>
          </div>
        </template>
        <template #arrival_method="{ row }">
          <div class="table-default__controls">
          <span
            class="table-default__transport table-default__transport--arrival"
            :class="{
            'table-default__transport--present': row.client.transport.arrival.arrival_method,
            'table-default__transport--confirmed': row.client.transport.arrival.arrival_confirmed,
            'table-default__transport--car': row.client.transport.arrival.arrival_method?.code === 'car',
            'table-default__transport--bus': row.client.transport.arrival.arrival_method?.code === 'bus',
            'table-default__transport--self': row.client.transport.arrival.arrival_method?.code === 'self'
          }"
          ></span>
          </div>
        </template>
        <template #arrival_date="{ row }">
          {{ row.client.transport.arrival.arrival_date ? dateFormat(row.client.transport.arrival.arrival_date) : '-' }}
          {{ row.client.transport.arrival.arrival_time ? row.client.transport.arrival.arrival_time : '' }}
        </template>
        <template #arrival_location="{ row }">
          {{ row.client.arrival_location ? row.client.transport.arrival.arrival_location.name : '-' }}
        </template>
        <template #arrival_notes="{ row }">
          <div class="table-default__controls">
            <div
              v-tooltip="{ content: row.client.transport.arrival.arrival_notes, placement: 'left', offset: 10 }"
              class="table-default__activity table-default__activity--notes"
              :class="{'table-default__activity--active': row.client.transport.arrival.arrival_notes}"
            ></div>
          </div>
        </template>
      </v-client-table>
    </template>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete briefing
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this briefing?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteEvent" ref="deleteEvent">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="event-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideEventModal" class="popup__close" type="button"></button>
        <div class="popup__title">{{ !event_to_update ? 'Creating new briefing' : 'Updating briefing' }}</div>
        <div class="popup__body">
          <app-grid>
            <template #item-1>
              <app-form-group>
                <app-cells :indent="false">
                  <app-checkbox
                    v-model="form.briefing"
                    label="Briefing"
                  />
                  <app-checkbox
                    v-model="form.eq_check"
                    label="Equipment check"
                  />
                </app-cells>
              </app-form-group>
              <app-form-group label="Date" required>
                <app-date-picker
                  v-model="form.date"
                  placeholder="Date"
                  :error="$v.form.date.$error"
                />
                <template #error>
                  <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
                </template>
              </app-form-group>
              <app-cells :indent="false" :wrap="false">
                <app-form-group label="Time start" label-for="time_start" required>
                  <app-input
                    v-model="form.time_start"
                    v-mask="'99:99'"
                    placeholder="Time start"
                    autocomplete="off"
                    id="time_start"
                    name="time_start"
                    @paste.native.prevent
                    :error="$v.form.time_start.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.time_start.$dirty && !$v.form.time_start.required">Required field</div>
                    <div v-if="$v.form.time_start.$dirty && !$v.form.time_start.timeRegex">Wrong time</div>
                  </template>
                </app-form-group>
                <app-form-group label="Time end" label-for="time_end" required>
                  <app-input
                    v-model="form.time_end"
                    v-mask="'99:99'"
                    placeholder="Time end"
                    autocomplete="off"
                    id="time_end"
                    name="time_end"
                    @paste.native.prevent
                    :error="$v.form.time_end.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.time_end.$dirty && !$v.form.time_end.required">Required field</div>
                    <div v-if="$v.form.time_end.$dirty && !$v.form.time_end.timeRegex">Wrong time</div>
                  </template>
                </app-form-group>
              </app-cells>
              <app-form-group label="Location" required>
                <app-select
                  @input="onLocationSelected"
                  @search="onLocationSearch"
                  v-model="form.location"
                  :options="location_options"
                  :clearable="false"
                  placeholder="Location"
                  :error="$v.form.location.$error"
                />
                <template #error>
                  <div v-if="$v.form.location.$dirty && !$v.form.location.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #item-2>
              <app-form-group label="Managers" required>
                <app-select
                  v-model="form.managers"
                  :options="manager_options"
                  :display-field="option => `${option.first_name} ${option.last_name}`"
                  label="first_name"
                  placeholder="Managers"
                  multiple
                  :error="$v.form.managers.$error"
                />
                <template #error>
                  <div v-if="$v.form.managers.$dirty && !$v.form.managers.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group v-if="form.briefing" label="Speech" required>
                <app-select
                  v-model="form.speech"
                  :options="form.managers"
                  :clearable="false"
                  :display-field="option => `${option.first_name} ${option.last_name}`"
                  label="first_name"
                  placeholder="Speech"
                  :error="$v.form.speech.$error"
                />
                <template #error>
                  <div v-if="$v.form.speech.$dirty && !$v.form.speech.required">Required field</div>
                </template>
              </app-form-group>
            </template>
          </app-grid>
          <app-form-group label="Notes" label-for="notes">
            <app-textarea
              v-model="form.notes"
              id="notes"
              placeholder="Notes"
            />
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button
              @click.native="onCheckForm"
              ref="createEvent"
              :disabled="$v.form.$error"
            >
              {{ !event_to_update ? 'Create briefing' : 'Update briefing' }}
            </app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="safari-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('safari-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/safari-modal-icon.svg" alt="Safari">
          <span>Safari</span>
        </div>
        <div class="popup__body">
          <div class="popup__activities">
            <div
              v-for="activity of safari_modal_data"
              :key="activity.id"
              class="popup__activity"
            >
              <div class="popup__activity-info">
                <div class="popup__activity-row popup__activity-row--single">
                  <div class="popup__activity-values">
                    <span>Group Name:</span>
                    <router-link
                      :to="{name: 'safari-groups-detail', params: {id: activity.id}}"
                      class="popup__activity-link"
                    >
                      {{ activity.name }}
                    </router-link>
                  </div>
                </div>
                <div class="popup__activity-row">
                  <div class="popup__activity-values">
                    <span>Tour start:</span>
                    <span>{{ dateFormat(activity.tour_start) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Tour finish:</span>
                    <span>{{ dateFormat(activity.tour_end) }}</span>
                  </div>
                  <div class="popup__activity-values">
                    <span>Duration:</span>
                    <span>{{ activity.duration }} days</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onShowEventModal(null)">Create briefing</app-button>
    </div>
  </div>
</template>

<script>
import {
  deleteClimbingBriefing,
  getClimbingBriefings,
  getClimbingClientsForBriefings,
  getGoogleSearch,
  getUsers,
  patchClimbingBriefing,
  postClimbingBriefing,
  postLocation,
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'ClimbingGroupsDetailBriefings',
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      table: {
        items: [],
        columns: [
          'name',
          'time_start',
          'invoices_count',
          'speech',
          'managers',
          'created_by',
          'controls'
        ],
        options: {
          headings: {
            'name': 'Name',
            'time_start': 'Time & Location',
            'invoices_count': 'Invoices',
            'speech': 'Speech',
            'managers': 'Managers',
            'created_by': 'Created by',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_clients: {
        items: [],
        columns: ['select', 'full_name', 'hotel', 'group', 'safari', 'arrival_method', 'arrival_date', 'arrival_location', 'arrival_notes'],
        options: {
          headings: {
            select: '',
            full_name: 'Full name',
            hotel: 'Hotel',
            group: 'Group',
            safari: 'Safari',
            arrival_method: 'Transport',
            arrival_date: 'Date',
            arrival_location: 'Location',
            arrival_notes: 'Notes',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      event_to_delete: null,
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      form: {
        briefing: true,
        eq_check: true,
      },
      manager_options: [],
      location_options: [],
      clients_options: [],
      event_to_update: null,
      safari_modal_data: [],
      family_url: process.env.VUE_APP_FAMILY,
    }
  },
  validations: {
    form: {
      speech: {
        required: requiredIf(function() {
          return this.form.briefing
        })
      },
      time_start: { timeRegex, required },
      time_end: { timeRegex, required },
      managers: { required },
      date: { required },
      location: { required },
      clients: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_show_table_clients() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('climbing_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor')
        || this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table_clients.items.forEach(item => {
          if (!this.checked.includes(item.id) && (!item.briefing || !item.eq_check)) this.checked.push(item)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  created() {
    this.fetchEvents()
    if (this.is_show_table_clients) this.fetchClients()
    getUsers({ group: 'operations_manager,operations_supervisor', is_active: true }).then(response => { this.manager_options = response.data })
  },
  methods: {
    onLocationSelected({ name, place_id }) {
      postLocation({ name, place_id }).then(res => {
        this.form.location = res.data
      })
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.createEvent.preload = true
      if (!this.event_to_update) {
        postClimbingBriefing(this.normalizeForm())
          .then(() => {
            this.fetchEvents()
            this.fetchClients()
            this.$notify({
              type: 'success',
              title: 'Briefing created',
            })
            this.onHideEventModal()
            this.checked = []
          })
          .catch(() => {
            this.$refs.createEvent.preload = false
          })
      } else {
        patchClimbingBriefing(this.event_to_update, this.normalizeForm())
          .then(() => {
            this.fetchEvents()
            this.fetchClients()
            this.$notify({
              type: 'success',
              title: 'Briefing updated',
            })
            this.onHideEventModal()
          })
          .catch(() => {
            this.$refs.createEvent.preload = false
          })
      }
    },
    normalizeForm() {
      const form = {...this.form}
      form.clients = form.clients.map(item => item.id)
      form.location = form.location.id
      form.managers = form.managers.map(item => item.id)
      if (!form.briefing) form.speech = null
      else form.speech = form.speech.id
      return form
    },
    fetchEvents() {
      getClimbingBriefings({ climbing_group: this.$route.params.id })
        .then(response => {
          this.table.items = response.data
        })
    },
    fetchClients() {
      getClimbingClientsForBriefings({ climbing_group: this.$route.params.id, assigned: false })
        .then(response => {
          this.table_clients.items = response.data
          this.clients_options = response.data
        })
    },
    onShowEventModal(event) {
      if (!event) {
        this.event_to_update = null
        this.form.clients = this.checked
      } else {
        this.event_to_update = event.id
        this.form = {
          briefing: event.briefing,
          eq_check: event.eq_check,
          clients: event.clients,
          location: event.location,
          date: event.date,
          managers: event.managers,
          speech: event.speech || null,
          time_start: event.time_start,
          time_end: event.time_end,
        }
      }
      this.$modal.show('event-modal')
    },
    onHideEventModal() {
      this.$modal.hide('event-modal')
      this.form = {}
      this.$v.form.$reset()
    },
    onShowDeleteModal(event_id) {
      this.event_to_delete = event_id
      this.$modal.show('delete')
    },
    onDeleteEvent() {
      this.$refs.deleteEvent.preload = true
      deleteClimbingBriefing(this.event_to_delete)
        .then(() => {
          this.fetchEvents()
          this.fetchClients()
          this.$modal.hide('delete')
          this.$notify({
            type: 'success',
            title: 'Briefing deleted',
          })
        })
        .catch(() => {
          this.$refs.deleteEvent.preload = false
        })
    },
    onShowSafariModal(data) {
      if (!data.safari.length) return
      this.safari_modal_data = data.safari
      this.$modal.show('safari-modal')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy')
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    dateMonthFormat(date) {
      return date ? format(parseISO(date), 'dd MMM') : '-'
    },
    clientTableList(clients) {
      let result = ''
      for (const key in clients) {
        result += `${clients[key].first_name} ${clients[key].last_name}<br>`
      }
      return result
    },
    tooltipContent(data, type) {
      let managers = ''
      data[type].managers.forEach(item => {
        managers += `${item.full_name}, `
      })
      managers = managers.slice(0, -2)
      if (type === 'briefing') return `${this.dateFormat(data.briefing.date)} ${data.briefing.time_start} - ${data.briefing.time_end}<br>Managers: ${managers}<br>${data.briefing.location.short_name}`
      return `${this.dateFormat(data.eq_check.date)} ${data.eq_check.time_start} - ${data.eq_check.time_end}<br>Managers: ${managers}<br>${data.eq_check.location.short_name}`
    },
    tooltipContentSafari(data) {
      let result = ''
      data.forEach(item => {
        result += `${item.name} (${this.dateFormat(item.tour_start)} - ${this.dateFormat(item.tour_end)})<br>`
      })
      return result
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
